<template>
 <v-container fluid>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
          @click="openDialog"
        >
        <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Add new restaurant </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="CITY"
                  class="font-weight-bold"
                  v-model="DIALOG_ITEM.CITY"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="RESTAURANT"
                  v-model="DIALOG_ITEM.RESTAURANT"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="GENRE"
                  v-model="DIALOG_ITEM.GENRE"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="URL_LINK"
                  v-model="DIALOG_ITEM.URL_LINK"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-spacer></v-spacer>
        <p class="red--text"> {{ ERROR_MSG }} </p>
        </v-card-text>
        <v-card-actions>
        
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>

export default {
    name: 'autoaddnewdata',
    props: ['ITEM'],
    data() {
      return {
        ERROR_MSG: '',
        dialog: false,
        ITEM_BEFORE: this.ITEM,
        DIALOG_ITEM: this.ITEM
      }
    },
    methods: {
        saveData() {
            if (!this.DIALOG_ITEM.CITY) {
                this.ERROR_MSG = "CITY is required!";
            } else if (!this.DIALOG_ITEM.RESTAURANT) {
                this.ERROR_MSG = "RESTAURANT is required!";
            } else if (!this.DIALOG_ITEM.GENRE) {
                this.ERROR_MSG = "GENRE is required!";
            }  else {
                this.ERROR_MSG = '';
                console.log("SAVE " , this.DIALOG_ITEM);
                var response = this.$parent.postApiData(this.DIALOG_ITEM);
                console.log("RESPONSE: ", response);
                this.dialog = false;
            }
        },
        openDialog() {
          this.dialog = true
          if (this.ITEM_BEFORE == this.ITEM) {
            return null
          } else {
            this.ITEM_BEFORE = this.ITEM;
            this.DIALOG_ITEM = JSON.parse(JSON.stringify(this.ITEM));
          }
          
        }

    },
    watch: {
      ITEM: function () {
        this.openDialog()
      }
    }   
}
</script>



<style scoped>
p{
    font-size: 10px;
}
a {
    color: #0067a7 !important;
    text-decoration: none;
    font-size: 16px;
}
a:hover {
    color: #0c0c0c;
    text-decoration: underline;
}

.lunch-table-header {
    text-align: center;
    background-color: #e6e6e6;
}

thead {
    border-bottom-width: 2px;
    vertical-align: bottom;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}

th {
    border-bottom-width: 2px;
    vertical-align: top;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}


td {
    border: 1px solid #e9ecef;
    padding-left: 10px;
}


table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.01rem;
    background-color: transparent;
    border-collapse: collapse;
    border: 1px solid #e9ecef;
    display: table;
    white-space: normal;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    font-variant: normal;
}

.w-66 {
    width: 66% !important;
}
.w-33 {
    width: 33% !important;
}


</style>